var _rect, _g, _ellipse, _ellipse2, _path, _rect2, _rect3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20_360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17L7.56476 16.0646C6.07068 14.5624 4.83515 13.2715 3.85816 12.192C2.88116 11.1125 2.10687 10.1538 1.53528 9.31574C0.963695 8.47769 0.564919 7.71312 0.338951 7.02203C0.112984 6.33094 0 5.62975 0 4.91846C0 3.52251 0.42512 2.35379 1.27536 1.41228C2.1256 0.470761 3.18102 0 4.44161 0C5.22994 0 5.9748 0.206681 6.67616 0.620044C7.37754 1.03341 7.98549 1.63302 8.5 2.41888C9.03151 1.63302 9.64316 1.03341 10.3349 0.620044C11.0267 0.206681 11.7679 0 12.5584 0C13.819 0 14.8744 0.470575 15.7246 1.41172C16.5749 2.35289 17 3.52118 17 4.91659C17 5.62904 16.887 6.33083 16.661 7.02196C16.4351 7.7131 16.0364 8.47751 15.465 9.31518C14.8936 10.1529 14.1203 11.1118 13.1449 12.192C12.1696 13.2722 10.933 14.5631 9.43524 16.0646L8.5 17ZM8.5 15.0913C9.93701 13.6469 11.1218 12.4114 12.0543 11.3848C12.9868 10.3581 13.7244 9.46419 14.2671 8.70298C14.8098 7.94179 15.1878 7.2657 15.4011 6.67471C15.6144 6.08372 15.7211 5.49853 15.7211 4.91915C15.7211 3.91481 15.4198 3.0799 14.8172 2.41442C14.2146 1.74896 13.4635 1.41623 12.564 1.41623C11.8477 1.41623 11.1852 1.64303 10.5767 2.09663C9.96809 2.55022 9.47658 3.1907 9.10212 4.01808H7.89788C7.51756 3.18422 7.02458 2.54211 6.41894 2.09175C5.8133 1.6414 5.15232 1.41623 4.43599 1.41623C3.54234 1.41623 2.79275 1.74896 2.18722 2.41442C1.58169 3.0799 1.27892 3.91498 1.27892 4.91965C1.27892 5.49924 1.38578 6.08463 1.5995 6.67582C1.81322 7.26701 2.19104 7.9428 2.73298 8.70318C3.27493 9.46357 4.01207 10.3566 4.9444 11.3822C5.87674 12.4078 7.06193 13.6442 8.5 15.0913Z",
    fill: "#FB3958"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5.5,
    rx: 4,
    ry: 4.5,
    fill: "#FB3958"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 5.5,
    rx: 4,
    ry: 4.5,
    fill: "#FB3958"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.5L15.5 8L8.5 7.5L1.5 8L8.5 15.5Z",
    fill: "#FB3958"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_360)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#121212"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20_360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#121212"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17L7.56476 16.0646C6.07068 14.5624 4.83515 13.2715 3.85816 12.192C2.88116 11.1125 2.10687 10.1538 1.53528 9.31574C0.963695 8.47769 0.564919 7.71312 0.338951 7.02203C0.112984 6.33094 0 5.62975 0 4.91846C0 3.52251 0.42512 2.35379 1.27536 1.41228C2.1256 0.470761 3.18102 0 4.44161 0C5.22994 0 5.9748 0.206681 6.67616 0.620044C7.37754 1.03341 7.98549 1.63302 8.5 2.41888C9.03151 1.63302 9.64316 1.03341 10.3349 0.620044C11.0267 0.206681 11.7679 0 12.5584 0C13.819 0 14.8744 0.470575 15.7246 1.41172C16.5749 2.35289 17 3.52118 17 4.91659C17 5.62904 16.887 6.33083 16.661 7.02196C16.4351 7.7131 16.0364 8.47751 15.465 9.31518C14.8936 10.1529 14.1203 11.1118 13.1449 12.192C12.1696 13.2722 10.933 14.5631 9.43524 16.0646L8.5 17ZM8.5 15.0913C9.93701 13.6469 11.1218 12.4114 12.0543 11.3848C12.9868 10.3581 13.7244 9.46419 14.2671 8.70298C14.8098 7.94179 15.1878 7.2657 15.4011 6.67471C15.6144 6.08372 15.7211 5.49853 15.7211 4.91915C15.7211 3.91481 15.4198 3.0799 14.8172 2.41442C14.2146 1.74896 13.4635 1.41623 12.564 1.41623C11.8477 1.41623 11.1852 1.64303 10.5767 2.09663C9.96809 2.55022 9.47658 3.1907 9.10212 4.01808H7.89788C7.51756 3.18422 7.02458 2.54211 6.41894 2.09175C5.8133 1.6414 5.15232 1.41623 4.43599 1.41623C3.54234 1.41623 2.79275 1.74896 2.18722 2.41442C1.58169 3.0799 1.27892 3.91498 1.27892 4.91965C1.27892 5.49924 1.38578 6.08463 1.5995 6.67582C1.81322 7.26701 2.19104 7.9428 2.73298 8.70318C3.27493 9.46357 4.01207 10.3566 4.9444 11.3822C5.87674 12.4078 7.06193 13.6442 8.5 15.0913Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3412ed1b99cb879b02c911d73fe8b484.svg";
export { ForwardRef as ReactComponent };